export const ADMIN = 'ADMIN';
export const SUPER_ADMIN = 'SUPER_ADMIN';
